import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from "@material-ui/core";
import CloseIcon from '@mui/icons-material/Close';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import { MaterialReactTable } from "material-react-table";
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import PageTitle from "../../../components/PageTitle/PageTitle";
import PdfUpload from "../../../utils/Uploader/PdfUpload";
import PdfUpload2 from "../../../utils/Uploader/PdfUpload2";
import axios from '../../../utils/axios';

import 'dayjs/locale/en-gb';

import ReplyIcon from '@mui/icons-material/Reply';

import 'dayjs/locale/en-gb';


const formatDate = (value) => new Date(value).toLocaleDateString();
// Modal component
const PdfPreviewModal = ({ open, onClose, filePreview }) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    height: '95vh',
    bgcolor: 'background.paper',
    border: '2px solid #eee',
    boxShadow: 24,
    p: 2,
    borderRadius: "10px",
    textAlign: "center"
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <h3>PDF Viewer</h3>
          {
            filePreview ? (
              <embed src={filePreview} width="100%" height="90%" type="application/pdf" />
            ) : (
              <Typography>Oops! The file is not uploaded yet.</Typography>
            )
          }
          <Button variant="contained" color="primary" onClick={onClose}><CloseIcon /> Close</Button>
        </Box>
      </Fade>
    </Modal>
  );
};

const PdfUploadModal = ({ open, onClose, uploadRowData, setUploadRowData }) => {
  
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    height: '60vh',
    bgcolor: 'background.paper',
    border: '2px solid #eee',
    boxShadow: 24,
    p: 2,
    borderRadius: "10px",
    textAlign: "center"
  };

  const [saving, setSaving] = useState(false);
  const [openPreview,setOpenPreview] = useState(false);
  const [fileURL, setFileURL] = useState('');

const handlePdfChange2 = (e) => {
  console.log("file",e)
    const file = e.target.files[0];
    if (file) {
      setUploadRowData( prevValues => {
                 return { ...prevValues,pfil: file}});
    }}
const handleOpenPreview = () =>{
      return(
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openPreview}
        onClose={()=>{setOpenPreview(false);} }
        closeAfterTransition
        BackdropComponent={Backdrop}
        slots={{ backdrop: Backdrop }}
        slotProps={{
        backdrop: {
            timeout: 500,
        }}}
       style={{overflow: "auto", display:"flex",justifyContent:"center",alignItems:"center", textAlign:"center", borderRadius:"10px"
       }}
       >
        <Fade in={open}>
        <Box sx={style} style={{textAlign:"center",width:"80%",height:"80vh"}} >
            <h3>PDF PREVIEWER2 </h3>
            <Box className="form-control" style={{textAlign:"center",height:"90%"}}>
                {uploadRowData.pfil ? (
                    // <div
                    //     style={{
                    //         border: '1px solid rgba(0, 0, 0, 0.3)',
                    //         height: '100%',
                    //     }}
                    // >
                    //     <Viewer fileUrl={fileURL} />
                    // </div>
                    <iframe
                        src={uploadRowData.pfil ? URL.createObjectURL(uploadRowData.pfil) : ''}
                        width="100%"
                        height="100%"
                        title="PDF Viewer"
                      />
                ) : (
                    <div
                        style={{
                            alignItems: 'center',
                            border: '2px dashed rgba(0, 0, 0, .3)',
                            display: 'flex',
                            fontSize: '2rem',
                            height: '100%',
                            justifyContent: 'center',
                            width: '100%',
                        }}
                    >
                        Please upload a PDF file to preview.
                    </div>
                )}
                
                <Button type="button" onClick={()=>{setOpenPreview(false);}} variant="contained" color="info" style={{color:"white"}}><ReplyIcon/> Close</Button>
                </Box>
        </Box>
        </Fade>
    </Modal>
      )

      
    }

const handleSavePdf = async () => {
  console.log("up",uploadRowData)
  
  const formData = new FormData();
  formData.append("settlementNoId", uploadRowData.ids);
  formData.append("dividendType", uploadRowData.dividendtype);
  formData.append("settlementno", uploadRowData.pfil);

  try {
    setSaving(true);
    const res = await axios.put("/settlement-no", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    Swal.fire({
      icon: "success",
      title: "PDF Uploaded",
      text: "PDF has been successfully uploaded.",
    }).then(() => {
      // ✅ Reload the page after success alert
      window.location.reload();
    });

    // You can optionally call these before reload (or remove them if reload clears them anyway)
    onClose();
    setUploadRowData({});

  } catch (error) {
    console.error("Upload error:", error);
    Swal.fire({
      icon: "error",
      title: "Upload Failed",
      text: error.response?.data?.message || "Something went wrong.",
    });
  } finally {
    setSaving(false);
  }
};



  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <h3>Upload PDF</h3>
          <div style={{ fontSize: '1rem', fontWeight: 'bold', marginBottom: '1rem' }}>
            <p>Settlement No: {uploadRowData.settlementno}</p>
            <p>Dividend Type: {uploadRowData.dividendtype}</p>
            <p>Settlement Amount: {uploadRowData.settlementamount}</p>
          </div>

          <PdfUpload2
          FILEID="pfil"
          submitValue={uploadRowData} 
          setSubmitValue={setUploadRowData}
          />






          <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center', gap: '1rem' }}>
            <Button variant="contained" color="primary" onClick={handleSavePdf} disabled={saving}>
              {saving ? "Saving..." : "Save PDF"}
            </Button>
            <Button variant="contained" color="secondary" onClick={onClose}>
              <CloseIcon /> Close
            </Button>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
};

const SettlementNoEntry = () => {
const [settlementData, setSettlementData] = useState([]);
const [previewOpen, setPreviewOpen] = useState(false);
const [filePreview, setFilePreview] = useState('');
const [isValid, setIsValid] = useState(false);
const [loading, setLoading] = useState(true);
const [openPreview,setOpenPreview] = useState(false);
const [uploadRowData, setUploadRowData] = useState({});
const [uploadRowData2, setUploadRowData2] = useState({});
const [uploadedPdfFile, setUploadedPdfFile] = useState(null);

  const [formData, setFormData] = useState({
    dividendType: '',
    lastSettlementNo: '',
    currentSettlementNo: '',
    settlementAmount: '',
    settlementDate: '',
    approvalDate: '',
    bankDispatchDate: '',
    folio_bo_file: null,
  });

  


const fetchSettlementData = async () => {
  setLoading(true); // Start loading
  try {
    const response = await axios.get('/settlement-no?dividend-type=All');
    if (response.data?.success) {
      setSettlementData(response.data.payload);
    }
  } catch (error) {
    console.error('Error fetching settlement data:', error);
  } finally {
    setLoading(false); // Stop loading
  }
};


useEffect(() => {
  fetchSettlementData();
}, []);

useEffect(() => {
  const { bankDispatchDate, lastSettlementNo, ...requiredFields } = formData;
  const allFilled = Object.values(requiredFields).every(val => val !== "" && val !== null);
  setIsValid(allFilled);
}, [formData]);


// Automatically update currentSettlementNo when lastSettlementNo changes
useEffect(() => {
  setFormData(prev => ({
    ...prev,
    currentSettlementNo: Number(prev.lastSettlementNo) + 1
  }));
}, [formData.lastSettlementNo]);



const handleChange = async (e) => {
  const { name, value } = e.target;

  // Update form field
  setFormData(prev => ({ ...prev, [name]: value }));

  // If dividendType is selected, fetch last settlement
  if (name === 'dividendType') {
    try {
      setLoading(true);
      const response = await axios.get(`/settlement-no?dividend-type=${value}`);
      if (response.data?.success && response.data.payload.length > 0) {
        const maxSettlement = Math.max(
          ...response.data.payload.map(item => parseInt(item.settlementno, 10))
        );
        setFormData(prev => ({
          ...prev,
          lastSettlementNo: maxSettlement.toString(), // Convert back to string
          dividendType: value
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          lastSettlementNo: '',
          dividendType: value
        }));
      }
    } catch (error) {
      console.error('Error fetching settlement by type:', error);
    } finally {
      setLoading(false);
    }
  }
};

  const handleSave = async () => {
    const form = new FormData();
    for (let key in formData) {
      if (key === 'folio_bo_file' && formData[key]) {
        form.append('settlementno', formData[key]);
      } else {
        form.append(key, formData[key]);
      }
    }

 try {
  const response = await axios.post('/settlement-no', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });

  Swal.fire({
    icon: 'success',
    title: 'Success',
    text: 'Settlement entry submitted successfully!',
  }).then(() => {
    // Reset the form
    setFormData({
      dividendType: '',
      lastSettlementNo: '',
      currentSettlementNo: '',
      settlementAmount: '',
      settlementDate: '',
      approvalDate: '',
      bankDispatchDate: '',
      folio_bo_file: null,
    });

    fetchSettlementData();
  });

} catch (error) {
  console.error("Axios POST error:", error);

  let errorMsg = error.response?.data?.message || error.message || "Unknown error";
  Swal.fire({
    icon: 'error',
    title: 'Submission Failed',
    text: errorMsg,
  });
}
  };

  const handlePreviewClick = async (row) => {
    try {
      const fileUrlFromDB = row.settlefile[0];
      const fileURLclean = fileUrlFromDB.replace(/^\["|"\]$/g, '');
      const response = await axios.post(`/settlement/get-settlement-file/${row.ids}`, {
        filename: fileURLclean,
      }, {
        responseType: 'blob',
      });

      const file = new Blob([response.data], { type: 'application/pdf' });
      const fileUrl = URL.createObjectURL(file);
      setFilePreview(fileUrl);
      setPreviewOpen(true);
    } catch (error) {
      console.error("Error fetching PDF:", error);
      if (error.response?.status === 404) {
        Swal.fire({ icon: "warning", title: "File Not Found", text: "The requested PDF file was not uploaded on the server." });
      } else {
        Swal.fire({ icon: "error", title: "Error", text: "Something went wrong while fetching the file!" });
      }
    }
  };

  // Table column show
  const columns = [
    {
      accessorKey: 'id',
      header: 'SL',
      size: 30,
      Cell: ({ row }) => <div>{row.index + 1}</div>,
    },
    { accessorKey: 'settlementno', header: 'Sett No', size: 30 },
    { accessorKey: 'dividendtype', header: 'Type', size: 30 },
    { accessorKey: 'settlementamount', header: 'Amount', size: 30 },

    {
      accessorKey: 'approveddate',
      header: 'Approval Date',
       Cell: ({ cell }) => {
        const value = cell.getValue();
        return value ? new Date(value).toLocaleDateString() : '';
      },
      size: 30,
    },
        {
      accessorKey: 'settlementdate',
      header: 'Settlement  Date',
       Cell: ({ cell }) => {
        const value = cell.getValue();
        return value ? new Date(value).toLocaleDateString() : '';
      },
      size: 30,
    },
    {
      accessorKey: 'bankdisbursementdate',
      header: 'Bank Disbursement Date',
        Cell: ({ cell }) => {
        const value = cell.getValue();
        return value ? new Date(value).toLocaleDateString() : '';
      },
      size: 30,
    },
    { accessorKey: 'createdby', header: 'Created By', size: 30 },
        {
      accessorKey: 'createdat',
      header: 'Created At',
        Cell: ({ cell }) => {
        const value = cell.getValue();
        return value ? new Date(value).toLocaleDateString() : '';
      },
      size: 30,
    },

{
  accessorKey: "settlefile",
  header: "Documents",
      muiTableBodyCellProps: {
      align: 'center', // ✅ center cell data
    },
    muiTableHeadCellProps: {
      align: 'center', // ✅ center header text
    },
  size: 30,
  Cell: ({ row }) => {
    const settlefile = row.original.settlefile;
    const hasFile = settlefile && Array.isArray(settlefile) && settlefile.length > 0 && settlefile[0];
    

    return (
      <>
      {
      hasFile 
      ?
      <Button
        variant="contained"
        color={"primary"}
        size="small"
        onClick={() => {
            handlePreviewClick(row.original);
        }}
      >
        View
      </Button>
      :
      <>
      <Button
    
        variant="contained"
        color="secondary"
        size="small"
        onClick={() => {

            setOpenPreview(true);
            setUploadRowData(row.original);
             // Open uploader
        }}
      >
        Upload
      </Button>
      </>
  }
      </>
    );
  }
}
  ];
  return (
    <>
      <PageTitle title="Settlement Number Entry" />
      <Grid container spacing={2} >
      <Grid item xs={12} md={12} style={{margin:"10px 0px 10px 5px",boxShadow:"1px 1px 1px 1px gray",padding:"10px",border:"1px solid slateblue",borderRadius:"5px"}}>
       
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <FormControl fullWidth required variant="outlined">
                <InputLabel id="dividend-type-label">Dividend Type</InputLabel>
                <Select
                  labelId="dividend-type-label"
                  name="dividendType"
                  value={formData.dividendType}
                  onChange={handleChange}
                  label="Dividend Type"
                >
                  <MenuItem value="Cash">Cash</MenuItem>
                  <MenuItem value="Stock">Stock</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={4}>
            <TextField
                  fullWidth
                 variant="outlined"
                  name="lastSettlementNo"
                  label="Last Settlement No"
                  type="number"
                  value={formData.lastSettlementNo}
                  InputProps={{ readOnly: true , style: { backgroundColor: '#f5f5f5' }}}
                />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                required fullWidth variant="outlined"
                name="currentSettlementNo" label="Current Settlement No" type="number"
                value={formData.currentSettlementNo} onChange={handleChange}
              />
            </Grid>
          </Grid>
       
       <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <TextField
                required fullWidth variant="outlined"
                name="settlementAmount" label="Settlement Amount" type="number"
                value={formData.settlementAmount} onChange={handleChange}
              />
            </Grid>
         
            <Grid item xs={12} md={3}>
              <TextField
                required fullWidth variant="outlined"
                name="approvalDate" label="Approval Date" type="date"
                value={formData.approvalDate} onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
               <Grid item xs={12} md={3}>
              <TextField
                required fullWidth variant="outlined"
                name="settlementDate" label="Settlement Date" type="date"
                value={formData.settlementDate} onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
           <TextField
              fullWidth
              variant="outlined"
              name="bankDispatchDate"
              label="Bank Dispatch Date"
              type="date"
              value={formData.bankDispatchDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
            />
            </Grid>
          </Grid>

          
        </Grid>
        
        <Grid item xs={12} style={{paddingTop:"5px", textAlign: "center"}}>
          <PdfUpload 
              //  key={formData.dividendType || Date.now()}
              submitValue={formData}
              setSubmitValue={setFormData}
            />
    
        </Grid>
            <Grid item xs={12} style={{padding:"2px"}}>
          <Grid container justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              disabled={!isValid}
              onClick={handleSave}
            >
              Save
            </Button>
          </Grid>
        </Grid>
     </Grid>

  
    <Grid item xs={12} md={12} style={{margin:"0px 0px 10px",boxShadow:"1px 1px 1px 1px gray",padding:"10px",border:"1px solid slateblue",borderRadius:"5px"}}>
                {loading ? (
            <Box display="flex" justifyContent="center" p={4}>
              <CircularProgress />
            </Box>
          ) : settlementData.length === 0 ? (
            <Box display="flex" justifyContent="center" p={4}>
              <Typography variant="h6">No Data Available</Typography>
            </Box>
          ) : (
            <MaterialReactTable 
              initialState={{ density: "compact" }}
              columns={columns}
              data={settlementData}
            />
          )}
        </Grid>
      </Grid>

      <PdfPreviewModal
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        filePreview={filePreview}
      />
      <PdfUploadModal
      open={openPreview}
      onClose={()=>setOpenPreview(false)}
      uploadRowData={uploadRowData}
      setUploadRowData={setUploadRowData}
      />
    </>
  );
};
export default SettlementNoEntry;
